import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var pollDataRes;
export const pollDataTodo = createAsyncThunk('pollData', async () => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_poll_data',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return pollDataRes = res.data
    } catch (error) {
        return pollDataRes = error.response.data
    }
})


const pollDataSlice = createSlice({
    name: 'pollData',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(pollDataTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('pollData', state.data)
            }
        });
        builder.addCase(pollDataTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default pollDataSlice.reducer; 